import { useQuery } from "react-query"

import axios from "axios"

import {
  FailureMessage,
  ServiceFailedToReturn,
  ServiceError,
  SellerFetchType,
  SellerInfoType,
} from "./types"
import { customerBaseApi, sellerInfoGetPath } from "./utils"

const transformResponse = (respondData: string) => {
  const data = JSON.parse(respondData)

  if (data?.code) {
    return respondData
  }

  const {
    name,
    receiptName,
    phoneNumber: orgPhoneNumber,
    contactEmail: orgContactEmail,
    privacyPolicyLink: orgPrivacyPolicyLink,
    profileImageUrl,
  } = data as SellerFetchType & ServiceError

  const orgLogoUrl = (profileImageUrl ?? "").replace("[size]", "m")

  return {
    orgName: receiptName ?? name,
    orgLogoUrl,
    orgPhoneNumber,
    orgContactEmail,
    orgPrivacyPolicyLink,
  }
}

export const useSellerInfo = (orgUuid: string) => {
  const getData = async () => {
    try {
      const { data } = await axios.get(customerBaseApi(sellerInfoGetPath(orgUuid)), {
        responseType: "json",
        validateStatus: (status: number) => status === 200,
        transformResponse,
      })

      return data
    } catch (err: any) {
      if (err.response?.status === 404) {
        return {
          failureMessage: FailureMessage.SELLER_NOT_FOUND,
        }
      }

      return {
        failureMessage: FailureMessage.OPERATION_ERROR,
      }
    }
  }

  return useQuery<SellerInfoType & ServiceFailedToReturn, { message: string }>(
    "purchase-details",
    getData,
    {
      retry: 0,
      refetchOnWindowFocus: false,
      enabled: !!orgUuid,
    },
  )
}
